import { createAction } from '@reduxjs/toolkit';

export const askQuestionAction = createAction('conference/askQuestionAction');
export const cancelCachQuestionsAction = createAction('conference/cancelCachQuestionsAction');
export const deleteQuestionAction = createAction('conference/deleteQuestionAction');
export const errorAction = createAction('conference/errorAction');
export const getAttendeeStatusAction = createAction('conference/getAttendeeStatusAction');
export const getCachedQuestionsAction = createAction('conference/getCachedQuestionsAction');
export const getConferenceAction = createAction('conference/getConferenceAction');
export const getStatusAction = createAction('conference/getStatusAction');
export const initAction = createAction('conference/initAction');
export const missNextCacheCallAction = createAction('conference/missNextCacheCallAction');
export const resetStateAction = createAction('conference/resetStateAction');
export const setAllQuestionsAction = createAction('conference/setAllQuestionsAction');
export const setCachedQuestionsAction = createAction('conference/setCachedQuestionsAction');
export const setConferenceAction = createAction('conference/setConferenceAction');
export const setQuestionAnswerAction = createAction('conference/setQuestionAnswerAction');
export const setQuestionHiddenAction = createAction('conference/setQuestionHiddenAction');
export const setStatusAction = createAction('conference/setStatusAction');
export const setVodResourcesAction = createAction('conference/setVodResourcesAction');
export const setupBroadcastSessionAction = createAction('conference/setupBroadcastSessionAction');
export const startConferenceSessionAction = createAction('conference/startConferenceSessionAction');
export const stopConferenceSessionAction = createAction('conference/stopConferenceSessionAction');
export const successAction = createAction('conference/successAction');
export const updateVodResourceAction = createAction('conference/updateVodResourceAction');
export const upvoteQuestionAction = createAction('conference/upvoteQuestionAction');
export const updateUserQuestionUpdatesAction = createAction(
  'conference/updateUserQuestionUpdatesAction'
);
export const clearUserQuestionUpdatesAction = createAction(
  'conference/clearUserQuestionUpdatesAction'
);
export const blockUserAction = createAction('conference/blockUserAction');
export const setBlockedUsersAction = createAction('conference/setBlockedUsersAction');
export const askForHelpAction = createAction('conference/askForHelpAction');
